import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { paths } from '@/core/router/paths';
import { mergeSx } from '@/utils/mergeSx';

import { errorStyles as sx } from './Error.styles';

type Props = {
	title?: string;
	description?: string;
	handleBack?: () => void;
	withoutBack?: boolean;
	withoutHeader?: boolean;
	customSx?: {
		root?: SxProps<Theme>;
		icon?: SxProps<Theme>;
	};
};

export const Error = ({
	title,
	description,
	handleBack,
	withoutBack,
	withoutHeader,
	customSx
}: Props) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleGoToHomePage = () => {
		if (handleBack) {
			handleBack();
		} else {
			navigate(paths.home);
		}
	};

	return (
		<Box sx={mergeSx(sx.root, customSx?.root)}>
			{!withoutHeader && (
				<Typography variant='h4' color='textSecondary'>
					{title ?? t('Something went wrong')}
				</Typography>
			)}

			<WarningAmberIcon sx={mergeSx(sx.searchIcon, customSx?.icon)} />

			<Typography variant='body1' color='textSecondary'>
				{description ?? t('An error occurred. Please try again.')}
			</Typography>

			{!withoutBack && (
				<Button
					startIcon={<NavigateBeforeIcon fontSize='small' />}
					sx={sx.backButton}
					aria-label={t('Back navigation')}
					onClick={handleGoToHomePage}
				>
					{t('BACK')}
				</Button>
			)}
		</Box>
	);
};
